/**
 * Created by Jie Gao on 7/30/2019.
 */
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {GGParsedGameData} from "../server/data/GGParsedGameData";
import {TimelineLite} from "gsap";
import {GGGameModuleConfig} from "../GGGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GGParsedInitData} from "../server/data/GGParsedInitData";
import {ITopTrain} from "../server/data/IGGServerData";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GGReelSymbolM} from "../symbols/GGReelSymbolM";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GGGameMode} from "../gamemode/GGGameMode";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GGGameConfig} from "../GGGameConfig";
import {GGHelper} from "../utils/Helper";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {GGReelSymbol} from "../symbols/GGReelSymbol";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";

export class GoblinSpell extends ReelStopPresentationController {
    private _timeline:TimelineLite | null;
    private _isRestoreState:boolean = false;
    private _allPoppedUp:boolean = false;
    private _allReelsStopped:boolean = false;
    private _stoppedReels:number[] = [];
    private _trainData:ITopTrain;
    private _nextMode:string;
    private _isRespin:boolean;
    private _isFreespin:boolean;
    private _isSuperFreespin:boolean;
    private _isNextRespin:boolean;
    private _isLastEvil4:boolean = false;
    private _newGoblinPos:boolean[];
    private _topTrainAnticipation:boolean[];
    private _multiplierBeforeFeast:number;
    private _evil4Triggered:boolean;
    private _hasWon:boolean = false;
    private _firstReelsAfterCollapse:string[];
    private _comingFromAs:boolean = false;

    constructor(index:number) {
        super(index, "GoblinSpell");
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, "STATING_BONUS_FROM_AS", () => {
            this._comingFromAs = true;
        })
    }

    private onInitDataParsed(data:GGParsedInitData):void {
        this._trainData = data.topTrain;
        this._isFreespin = data.mode.indexOf("FREESPIN") > -1;
        this._isRestoreState = data.isRestoreState;
        this._nextMode = data.nextMode;
        this._isSuperFreespin = data.roundType === 2;
        this._evil4Triggered = data.topTrain.evil4;
        this._firstReelsAfterCollapse = data.reelsAfterCollapse[0];
    }

    protected parseFeatureGameData(data:GGParsedGameData):void {
        this._trainData = data.topTrain;
        this._topTrainAnticipation = data.topTrainAnticipation;
        this._nextMode = data.nextMode;
        this._isRespin = data.isAvalancheMode;
        this._isNextRespin = this._nextMode.indexOf("AVALANCHE") > -1;
        this._isSuperFreespin = data.roundType === 2;
        this._isFreespin = data.isFreespinMode;
        this._multiplierBeforeFeast = data.multiplierBeforeFeast;
        this._hasWon = data.singleWin > 0;

        const trainData:ITopTrain = this._trainData;
        const newTopTrainSymbol:boolean[] = this._newGoblinPos;
        const evil4Triggered:boolean = !GGGameModuleConfig.topTrain.isEvil4Triggered && (<GGParsedGameData>this._gameData)!.topTrain.evil4;

        this._allPoppedUp = false;
        this._allReelsStopped = false;
        this._stoppedReels = [];

        this._evil4Triggered = evil4Triggered;
        this._isLastEvil4 = false;
        GGGameModuleConfig.soundPlayer.startNewRound();

        // #576
        if (GGGameConfig.instance.FAULTY_WIN_CAP) {
            return;
        }

        if (this._comingFromAs) {
            this._comingFromAs = false;
            return;
        }

        const tl:TimelineLite = new TimelineLite({paused : true});
        const startTime:number = (data.wasRandomBuy && (data.mode === GameMode.NORMAL)) ? 3.1 : 0.1;
        tl.add(GGGameModuleConfig.topTrain.goblinPopUp(trainData, newTopTrainSymbol, this._topTrainAnticipation, evil4Triggered), startTime);
        tl.add(this.showEvil4());
        if(!(evil4Triggered || (data.roundType === 2))){
            GGGameModuleConfig.topTrain.multiplierCountUp(this._trainData.evil4multiplier);
        }
        if(this._isSuperFreespin) {
            tl.add(this.showFrozenGoblin(trainData.frozenThisTurn, trainData.beforeSpellSymbols));
        }
        tl.add(() => {
            this._allPoppedUp = true;
            this.onAnimationComplete();
        });
        tl.play(0);
    }

    private onRestore():void {
        if(this._isRestoreState) {
            //const isSuperFS:boolean = (this._nextMode.indexOf(GGGameMode.FREESPIN_SUPER) > -1 || this._isSuperFreespin) && !(this._nextMode === GameMode.NORMAL);
            let resetPositions:boolean[] = ArrayHelper.initArrayWithValues(4, () => true);
            if(this._evil4Triggered) {
                GGGameModuleConfig.topTrain.resetOnRestore(this._trainData);
                this._firstReelsAfterCollapse.forEach((symbolName:string, i:number) => {
                    if(symbolName === this._trainData.evil4Symbol) {
                        const symbol:GGReelSymbolM = <GGReelSymbolM>Reels.getSymbol(0, i);
                        if(symbol == null || symbol.symName != this._trainData.evil4Symbol) {
                            debugger;
                        }
                        symbol.patchMultiplier(this._trainData.evil4multiplier);
                    }
                });
            }
            this._newGoblinPos = resetPositions;
        }
    }

    private onBeforeSpinStart():void {
        //show claws
        if(this._isRestoreState) {
            this._isRestoreState = false;
            return;
        }

        // #576
        if (GGGameConfig.instance.FAULTY_WIN_CAP) {
            return;
        }

        const data:ITopTrain = this._trainData;
        const forceReset:boolean = (this._nextMode === GameMode.NORMAL) || (this._nextMode === GGGameMode.DOUBLE_BOMB);
        if(forceReset) {
            GGGameModuleConfig.topTrain.resetEvil4();
        }
        //const isEvil4Triggered:boolean = GGGameModuleConfig.topTrain.isEvil4Triggered;
        //show claw when not frozen or untriggered,
        //show all claws if evil4 is triggered last round
        const resetPositions:boolean[] = ArrayHelper.initArrayWithValues(4, (i:number) => {
            if(!forceReset && data.frozenPositions[i]) {
                return false;
            }
            if(this._isNextRespin && !(data.symbols[i] === null)) {
                return false;
            }
            return true;
        });

        this._newGoblinPos = resetPositions;
        resetPositions.forEach((reset:boolean, i:number) => {
            if(reset) {
                GGGameModuleConfig.topTrain.resetSymbol(i, data.symbols[i]);
            }
        });
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if (GGGameConfig.instance.FAULTY_WIN_CAP) {
            this.dispatchCompleteEvent(data.reelId);

            return;
        }

        this._stoppedReels.push(data.reelId);

        if(this._stoppedReels.length === 6) {
            this._allReelsStopped = true;

            this.onAnimationComplete();

            return;
        }
        this.dispatchCompleteEvent(data.reelId);
    }

    private goblinSpell():void {
        const tl:TimelineLite = new TimelineLite({paused : true});

        const highLight:TimelineLite = new TimelineLite({paused : true});
        const goblinSpell:TimelineLite = new TimelineLite();
        const trainData:ITopTrain = (<GGParsedGameData>this._gameData)!.topTrain;
        const symbolsToWild:boolean[][] = trainData.goblinSpellTransform;
        const goblinSpellActivated:boolean[] = trainData.goblinSpellActivated;
        const frozenPositions:boolean[] = trainData.frozenPositions;
        let transformNum:number = 0;
        symbolsToWild.forEach((symbolsToWildOnReel:boolean[], i:number) => {
            if(goblinSpellActivated[i]) {
                transformNum++;
                symbolsToWildOnReel.forEach((symbolToWildOnReel:boolean, j:number) => {
                    if(symbolToWildOnReel) {
                        const symbol:StateReelSymbol = Reels.getSymbol(i, j)!;
                        if(symbol == null) {
                            debugger;
                            throw new Error(`Evil4.startWinPresentation(): Cannot find symbol at reelId = ${i}, symbolId = ${j}.`);
                        }

                        const animationScale:number = MathHelper.roundToDecimals((<GGReelSymbol>symbol).symHeight / 181, 2);
                        const toNWHighLight = GGHelper.createSpineAnimation("GS_Highlight");
                        highLight.add(() => {
                            StageManager.getLayer(GGGameConfig.instance.LAYERS.GOBLINS.name).addChild(toNWHighLight);
                            toNWHighLight.position = GGHelper.copyLocalPosition(toNWHighLight, symbol);
                            toNWHighLight.scale.set(1, animationScale);
                            toNWHighLight.state.setAnimation(0, "Highlight", false);
                            toNWHighLight.visible = true;
                        }, 0);
                        highLight.add(() => toNWHighLight.destroy(), 0.4);
                    }
                });
                if(frozenPositions[i - 1]) {
                    goblinSpell.add(GGGameModuleConfig.topTrain.goblinFrozenActivate(i - 1, trainData.beforeSpellSymbols[i - 1]), 0);
                }
                if(!frozenPositions[i - 1]) {
                    goblinSpell.add(GGGameModuleConfig.topTrain.goblinActivate(i - 1, trainData.beforeSpellSymbols[i - 1]), 0);
                }
            }
        });
        if(transformNum > 0) {
            if(this._hasWon) {
                tl.add(() => {
                    GGGameModuleConfig.soundPlayer.playBombThrowHighLightSound();
                    highLight.play(0);
                }, 0);
                tl.add(() => GGGameModuleConfig.soundPlayer.playWildBombHit(), 0.5);
            }
            tl.add(goblinSpell, 0);
            tl.add(() => GGGameModuleConfig.soundPlayer.playGoblinThrowBombSound(), 0.3);
            //Time need to be adjusted with startTime in Eviel4Presentation.goblinActivate
            tl.add(() => GGGameModuleConfig.soundPlayer.playBombThrowSound(transformNum), 0.6);
        }
        tl.add(() => this.dispatchCompleteEvent(this._stoppedReels[5]));
        this._timeline = tl;
        this._timeline.play(0);
    }

    private showFrozenGoblin(frozenThisTurn:boolean[], beforeSpellSymbols:string[]):TimelineLite {
        const timeline:TimelineLite = new TimelineLite();
        let newFrozenGoblin:boolean = false;
        frozenThisTurn.forEach((frozen:boolean, i:number) => {
            if(frozen) {
                newFrozenGoblin = true;
                timeline.add(GGGameModuleConfig.topTrain.showFrozenSymbol(i, beforeSpellSymbols[i]), 1);
            }
        });
        if(newFrozenGoblin) {
            const gapDuration:number = 0.5;
            timeline.add(() => GGGameModuleConfig.soundPlayer.playGoblinToSkeletonSound(), 1);
            timeline.add(GGGameModuleConfig.topTrain.multiplierCountUp(this._trainData.evil4multiplier), 1.5 + gapDuration);
            let startTime:number = timeline.duration() + gapDuration;
            timeline.add(GGGameModuleConfig.fsCounter.updateToSpinsLeft(4), startTime);
        }
        return timeline;
    }

    private showEvil4():TimelineLite {
        const timeline:TimelineLite = new TimelineLite();
        const data:GGParsedGameData = (<GGParsedGameData>this._gameData)!;
        const hasEvil4:boolean = data.topTrain.evil4;
        if(!hasEvil4) {
            return timeline;
        }
        const evil4Symbol:string = data.topTrain.evil4Symbol;
        const evil4Multiplier:number = ((data.multiplierBeforeFeast > -1) ? data.multiplierBeforeFeast : data.topTrain.evil4multiplier);
        if(!GGGameModuleConfig.topTrain.isEvil4Triggered) {
            timeline.add([
                () => {this._isLastEvil4 = true;},
                GGGameModuleConfig.topTrain.showEvil4(evil4Symbol, evil4Multiplier)
            ], 0);
        }
        return timeline;
    }

    private patchMultiplier():TimelineLite {
        const tl:TimelineLite = new TimelineLite({paused : true});
        const gameData:GGParsedGameData = <GGParsedGameData>this._gameData!;
        const multiplier:number = gameData.multiplierBeforeFeast > 0 ? gameData.multiplierBeforeFeast : gameData.topTrain.evil4multiplier;
        const patchTl:TimelineLite = GGGameModuleConfig.patchEvil4Multiplier.showEvil4Multipliers(gameData.reels[0], gameData.topTrain.evil4Symbol, multiplier, gameData.totalNumberOfWays[0]);
        if(patchTl.duration() > 0) {
            tl.add(() => GGGameModuleConfig.soundPlayer.playEvil4GoblinLandsOnReel1Sound(), 0);
        }
        tl.add(patchTl, 0);
        tl.play(0);
        return tl;
    }

    private onAnimationComplete():void {
        if(!(this._allPoppedUp && this._allReelsStopped)) {
            return;
        }
        const tl:TimelineLite = new TimelineLite();
        tl.add(this.patchMultiplier());
        tl.add(() => this.goblinSpell());
    }
}